import React, {useState, useEffect, useRef, useContext} from 'react';
import { useTranslation } from "react-i18next";
// import Serviced_vehicles from './Components/serviced_vehicles.js';
// import { Toast } from 'primereact/toast';
// import Loading from '../../Loading/loading';
// import { AuthContext } from "../../Header/auth - context";
// import { useSelector } from 'react-redux';
import { useSelector } from 'react-redux';
import { useDispatch } from "react-redux";
import { InputNumber } from 'primereact/inputnumber';
import { Dropdown } from 'primereact/dropdown';
import { Toast } from 'primereact/toast';
import { Card } from 'primereact/card';
import { TabMenu } from 'primereact/tabmenu';
import { AuthContext } from "../../../Header/auth - context";
import { confirmDialog } from 'primereact/confirmdialog';
import { ConfirmDialog } from 'primereact/confirmdialog'; // <- mora biti renderovana
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';

const BlagajnaUnos = () => {
  const { t } = useTranslation();

        const toast = useRef(null);
        const formRef = useRef(null);
        const auth = useContext(AuthContext);
        const company = useSelector(state => state.company)
        const eskaliran = useSelector(state => state.eskaliran)
        const role = useSelector(state => state.user_role)
        const trip = useSelector(state => state.trip)
        const user = useSelector(state => state.user)
        const [valutaOptions, setValutaOptions] = useState(null)
        const [trenutniSaldo, setTrenutniSaldo] = useState([])
        const [izabran, setIzabran] = useState(false)

        const [formSubmitted, setFormSubmitted] = useState(false);

        ///DATA
        const [formDataCurrentSaldo, setFormDataCurrentSaldo] = useState({
        Iznos: null,
        Valuta: null,
        Napomena: ''
        });


    const handleErrors = (response) => {
    if (response.ok) {
      return response.json();
    } else {
      throw response;
    }
  };


   useEffect(()=>{
    if(!formSubmitted){
                   let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              }
                          };
                          fetch(process.env.REACT_APP_BACKEND_URL + "/finance", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                
                                const stringifiedJson = data[0][""];
                                const parsedData = JSON.parse(stringifiedJson);

                                setValutaOptions(parsedData.ValuteDB)
                                setTrenutniSaldo(parsedData.TrenutniStatus)

                                // if(data){
                                //    (data) 
                                // }
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
    }
      },[formSubmitted])

const resetData = ()=> {
    setFormDataCurrentSaldo({
        Iznos: null,
        Valuta: null,
        Napomena: ''
    })
}

   const handleFormSubmit = (e) => {
  
                       e.preventDefault(); // bitno da ne submituje bez validacije
                  setFormSubmitted(true)
              if (formRef.current && !formRef.current.checkValidity()) {
                  formRef.current.reportValidity(); // prikazuje native browser poruke
                  return;
              }
      handleUploadAndSave()
   }
          const handleUploadAndSave = () => {
         
              confirmDialog({
              message: "Jel ste sigurni da želite nastaviti sa unosom?",
              acceptLabel: "Da",
              rejectLabel: "Ne",
              icon: "pi pi-info-circle",
              acceptClassName: "p-button-danger",
              accept: acceptInsert,
              reject: rejectInsert,
              });
          
  
      };
  
      const acceptInsert = async () => {
  
              //DATA
                  const hasAnyValueSaldo = Object.values(formDataCurrentSaldo).some(value => {
                  if (value === null || value === '') return false;
  
                  // Check if it's a valid Date object
                  if (value instanceof Date && isNaN(value.getTime())) return false;
  
                  return true;
                  });
  
                  if(hasAnyValueSaldo){
                      
                            let requestOptions = {
                              method: "POST",
                              headers: {
                              "Content-Type": "application/json",
                              Authorization: "Bearer " + auth.token,
                              },
                              body: JSON.stringify({
                                  formDataCurrentSaldo
                              }),
                          };
                  
                          await fetch(process.env.REACT_APP_BACKEND_URL + "/finance/InsertSaldo", requestOptions)
                              .then(handleErrors)
                              .then((data) => {
                                    
                                  if(data.message === 'Nedostaju obavezna polja za unos salda.'){
                                      toast.current.show({
                                      severity: "error",
                                      summary: "Error",
                                      detail: data.message,
                                      life: 3000,
                                      });
                                      return
                                  } 
                                  resetData()
                                  setFormSubmitted(false)
  
                                 toast.current.show({
                                  severity: "success",
                                  summary: "Uspešan unos podataka salda!",
                                  life: 3000,
                                  });

                                
                              //ubaciti deo da se forma ID za dalji unos
                              })
                              .catch((error) => {
                              error.json().then((errorMessage) => {
                                  toast.current.show({
                                  severity: "error",
                                  summary: "Error",
                                  detail: errorMessage.message,
                                  life: 3000,
                                  });
                                  console.log(errorMessage);
                              });
                              });
                  } else {
                          toast.current.show({
                          severity: "warn",
                          summary: "Upozorenje!",
                          detail: "Niste popunili podatke salda za unos!",
                          life: 3000,
                      });
                  }
  
    };
      const rejectInsert = () => {
      console.log("Odbijen unos podataka!");
    };     
  
    const handleChange = (e) => {
        const { name, value } = e.target;

        if (name in formDataCurrentSaldo) {
        setFormDataCurrentSaldo(prev => ({ ...prev, [name]: value }));
        }
    };
  
  
  const invalidControl = (data) => {
    if (!formSubmitted) return false; // ← NE prikazuj grešku dok forma nije poslata
  
    if (data && data != null && !Number(data)) {
      return data.length > 0 ? false : true;
    } else if (data != null && Number(data)) {
      return false;
    }
    return true;
  };

   return (
       <div style={{marginTop:"1%"}}> 
        <Toast ref={toast} />
        <div style={{marginLeft:"1%"}}>
            <div style={{display:'flex'}}><p style={{marginRight: '1%',marginBottom: '0', display:'flex', justifyContent: 'center', alignItems:'center'}}>Trenutni saldo:</p>{trenutniSaldo.map((item, i) => {
                            return (
                              <div key={i} style={{display:'flex', justifyContent: 'center', alignItems:'center', border: '1px solid rgb(224, 221, 221)', padding:'10px'}} >
                                <p style={{marginRight: '10px', marginBottom: '0',display:'flex', justifyContent: 'center', alignItems:'center'}} className={item.SumaKorigovana < 10 ? 'colorRed' : null}> <strong>{item.SumaKorigovana}</strong></p>
                                <p style={{marginRight: '10px', marginBottom: '0',display:'flex', justifyContent: 'center', alignItems:'center'}}><strong>[{item.Valuta}]</strong></p>
                              </div>
                            );
                          })}
            </div>
        </div>
        

        <ConfirmDialog />
              <div className="col-12"  style={{ borderBottom: '1px solid rgb(224, 221, 221)'}}>
                            
                            {(izabran) && <p class="infoPoruka">Putni nalog je seletovan. Moguće ažuriranje njegovih podataka.</p>}
                              <div className="gridHeader">
                                        {/* <h4>Izbor putnog naloga:</h4>
                                                 <CustomDropdown
                                                 style={{ width: "20%", marginLeft: '1%' }}
                                                 id="id_putni_nalog" 
                                                 name="id_putni_nalog" 
                                                 value={idTrip} 
                                                 options={tripsDB || []}
                                                 placeholder="Izaberi putni nalog"
                                                 optionLabel="Broj_putnog_naloga"
                                                 onChange={selectIdTripFUNC}
                                              
                                                                                                                            /> */}

                            </div>
            </div>
            <div className='col-12 md:col-6'>
               <form autoComplete="off" ref={formRef} style={{marginTop:'1%'}}>
                          <Card>
                            <div className="gridLicni">
                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="Iznos">{t('nova.iznos')}:</label>
                                 <InputNumber 
                                        id="Iznos" 
                                        name="Iznos" 
                                        required
                                        invalid={formDataCurrentSaldo.Iznos}
                                        value={formDataCurrentSaldo.Iznos} 
                                        onValueChange={handleChange}
                                        minFractionDigits={2}
                                        maxFractionDigits={2}
                                        />
                              </div>

                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                <label htmlFor="Valuta">{t('nova.valuta')}:</label>
                                          <Dropdown 
                                                                    id="Valuta" 
                                                                    name="Valuta" 
                                                                    required={formDataCurrentSaldo.Iznos == null ? false : true}
                                                                    invalid={formDataCurrentSaldo.Iznos != null ? invalidControl(formDataCurrentSaldo.Valuta) : null}
                                                                    value={formDataCurrentSaldo.Valuta} 
                                                                    options={valutaOptions || []} 
                                                                    onChange={handleChange}
                                                                    placeholder={t('nova.phValutu')}
                                                                />
                              </div>
                              <div className="col-12 md:col-6" style={{display: 'flex', flexDirection:'column'}}>
                                    <label htmlFor="Napomena">{t('nova.napomena')}:</label>
                                    <InputText 
                                    id="Napomena" 
                                    name="Napomena" 
                                    value={formDataCurrentSaldo.Napomena} 
                                    onChange={handleChange}
                                    />
                                </div>
                            </div>
                          </Card>
                    <div className="formUnosZap buttonUnosZap">
                      <button type="submit" onClick={handleFormSubmit} className="btn btn-success">
                        {izabran ? "SAČUVAJ" : "UNOS"}
                      </button>
                    </div>
                  </form>
            </div>                                

       </div>
   )
}
export default BlagajnaUnos;